/**
 * OaSIS Explorer Frontend - Trial Badge Component
 * Task 29.7B: Free Trial Period
 * 
 * Badge showing trial status with days remaining.
 */

import React from 'react';
import { Clock } from 'lucide-react';

interface TrialBadgeProps {
  /** Days remaining in trial */
  daysRemaining: number;
  /** Badge size */
  size?: 'sm' | 'md';
  /** Additional CSS classes */
  className?: string;
}

const sizeClasses = {
  sm: 'text-xs px-1.5 py-0.5 gap-0.5',
  md: 'text-xs px-2 py-1 gap-1',
};

const iconSizes = {
  sm: 10,
  md: 12,
};

/**
 * Trial Badge Component
 * Displays trial status with countdown
 */
export const TrialBadge: React.FC<TrialBadgeProps> = ({
  daysRemaining,
  size = 'sm',
  className = '',
}) => {
  return (
    <span 
      className={`inline-flex items-center font-medium rounded-full bg-amber-500/20 text-amber-400 ${sizeClasses[size]} ${className}`}
    >
      <Clock size={iconSizes[size]} />
      <span>Trial: {daysRemaining}d left</span>
    </span>
  );
};

export default TrialBadge;

